import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { File } from '@tran-monorepo/interfaces/files';
import { FileItemComponent } from '../file-item/file-item.component';
import { LoadMoreFilesComponent } from './../load-more-files/load-more-files.component';

@Component({
    selector: 'tran-file-list',
    imports: [FileItemComponent, LoadMoreFilesComponent],
    templateUrl: './file-list.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileListComponent {
    public readonly attachments = input<File[]>([]);
    public readonly hasMoreAttachments = input<boolean>(false);
    public readonly allowDownload = input<boolean>(true);
    public readonly allowDelete = input<boolean>(false);
    public readonly allowUndoDelete = input<boolean>(false);
    public readonly askDelete = input<boolean>(true);
    public readonly loadMore = output<void>();
    public readonly download = output<File>();
    public readonly delete = output<File>();
    public readonly undoDelete = output<File>();
}
